import React from "react";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import SvgIcon from "@mui/material/SvgIcon";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Minus as MinusIcon, Plus as PlusIcon } from "react-feather";

const AssetQuantityField = ({
  disabled,
  quantity,
  onChange,
  size = "medium",
  quantityProps = {},
  displayButtons = true,
  disablePlus = false,
  disableMinus = false,
  step = 1,
  inputReadOnly = false,
}) => {
  const labelTranslateY = size === "small" ? 9 : 16;

  const incrementQuqantity = () => {
    const current = quantity ? Number(quantity) : 0;
    const newQuantity = current + step;
    const rounded = Math.round(newQuantity * 100) / 100;
    onChange(rounded);
  };

  const decrementQuqantity = () => {
    const current = quantity ? Number(quantity) : 0;
    const newQuantity = current - step;
    const rounded = Math.round(newQuantity * 100) / 100;
    rounded >= 0 && onChange(rounded);
  };

  const getSizeStyles = () => {
    switch (size) {
      case "large":
        return {
          width: "160px",
          inputHeight: "28px",
        };
      case "small":
        return {
          width: "130px",
          inputHeight: "10px",
        };
      default:
        // medium
        return {
          width: "150px",
          inputHeight: "16px",
        };
    }
  };

  const sizeStyles = getSizeStyles();

  return (
    <FormControl>
      <TextField
        disabled={disabled}
        sx={{
          width: sizeStyles.width,
          "& .MuiInputLabel-root": {
            left: "50%",
            transform: `translate(-50%, ${labelTranslateY}px) scale(1)`,
            transformOrigin: "center",
          },
          "& .MuiInputLabel-root.MuiInputLabel-shrink": {
            transform: "translate(-50%, -9px) scale(0.75)",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            display: "flex",
            justifyContent: "center",
          },
          "& .MuiOutlinedInput-notchedOutline legend": {
            textAlign: "center",
          },
          "& .MuiOutlinedInput-root": {
            paddingRight: displayButtons ? "2px" : undefined,
            paddingLeft: displayButtons ? "2px" : undefined,
          },
          "& .MuiInputAdornment-root": {
            height: "auto",
            maxHeight: "none",
            alignSelf: "stretch",
          },
          "& .MuiInputAdornment-root .MuiIconButton-root": {
            height: "auto",
            alignSelf: "stretch",
          },
          "& input": {
            textAlign: "center",
            fontSize: sizeStyles.fontSize,
            height: sizeStyles.inputHeight,
            padding: size === "large" ? "14px 10px" : size === "small" ? "10px 6px" : "16.5px 14px",
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "&[type=number]": {
              MozAppearance: "textfield",
            },
          },
        }}
        variant="outlined"
        type="number"
        size={size}
        inputProps={{ min: 0, step: step, readOnly: inputReadOnly, inputMode: "numeric", onWheel: e => e.target.blur() }}
        onChange={event => onChange(Number(event.target.value))}
        onFocus={e => e.target.select()}
        value={quantity || ""}
        InputProps={{
          startAdornment: displayButtons && (
            <InputAdornment position="start">
              <IconButton
                disabled={disabled || disableMinus}
                onClick={decrementQuqantity}
                size="small"
                disableRipple
                sx={{
                  p: size === "large" ? 1 : 0.5,
                  pl: size === "large" ? 1.5 : 1,
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              >
                <SvgIcon sx={{ fontSize: sizeStyles.iconSize }}>
                  <MinusIcon />
                </SvgIcon>
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: displayButtons && (
            <InputAdornment position="end">
              <IconButton
                disabled={disabled || disablePlus}
                onClick={incrementQuqantity}
                size="small"
                disableRipple
                sx={{
                  p: size === "large" ? 1 : 0.5,
                  pr: size === "large" ? 2 : 1,
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <SvgIcon sx={{ fontSize: sizeStyles.iconSize }}>
                  <PlusIcon />
                </SvgIcon>
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...quantityProps}
      />
    </FormControl>
  );
};

export default AssetQuantityField;
